import {differenceInMinutes} from 'date-fns';
import {CalendarEventType} from './CalendarEventsFetch';

export enum CalendarEventSize {
	SMALL = 52,
	MEDIUM = 72,
	LARGE = 96,
}

export function getCalendarEventSize(event: CalendarEventType): CalendarEventSize {
	if (!event?.start || !event?.end) {
		return CalendarEventSize.SMALL;
	}
	const start = new Date(event.start);
	const end = new Date(event.end);
	const diffInMinutes = differenceInMinutes(end, start);
	if (diffInMinutes <= 30) {
		return CalendarEventSize.SMALL;
	} else if (diffInMinutes <= 120) {
		return CalendarEventSize.MEDIUM;
	} else {
		return CalendarEventSize.LARGE;
	}
}
